module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Incoming-mail-8b8ece04fb5b5fe7a60851facbc43cca.svg";